import { date, mixed, number, object, string } from 'yup'

import { ISSUE_RESPONSIBILITY } from '@img-arena/consoles-api-streaming'

export const issueFormValidationSchema = object().shape({
  startDate: date().required('Date is required.'),
  lossOfGamePlay: number().required('Loss of Game Play in minutes is required.'),
  problemDescription: string()
    .required('Provide a short description of a problem (max 1020 characters)')
    .max(1020, 'Problem description must be at most 1020 characters.')
    .min(1),
  responsibility: mixed<ValueOf<typeof ISSUE_RESPONSIBILITY>>()
    .oneOf(Object.values(ISSUE_RESPONSIBILITY))
    .required('Please select the scope.'),
  cases: object()
    .nullable()
    .when('responsibility', {
      is: ISSUE_RESPONSIBILITY.OTHER,
      then: (schema) =>
        schema.required('Both Issues Description and Duration are required.').shape({
          broadcastOther: object()
            .shape({
              description: string()
                .required('Issues Description is required.')
                .min(1, 'Issues Description is required.'),
              duration: string().required('Duration is required.').min(1, 'Duration is required.')
            })
            .required('Both Issues Description and Duration are required.')
        }),
      otherwise: (schema) => schema
    }),
  attachment: object()
    .shape({
      blobKey: string(),
      contentType: string(),
      fileName: string(),
      size: number()
    })
    .nullable()
})
